export default __webpack_public_path__ + "static/media/left-arrow.1aa77962.svg";